import React from 'react'
import PropTypes from 'prop-types'

const SettingsNumberLineNegativeScale = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    viewBox="765 391 1000 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Group"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(1265.000000, 395.000000) scale(-1, 1) translate(-1265.000000, -395.000000) translate(765.000000, 391.000000)"
    >
      <path
        d="M179,5 C179,6.65685425 180.343146,8 182,8 C183.656854,8 185,6.65685425 185,5 L201,5 C201,6.65685425 202.343146,8 204,8 C205.656854,8 207,6.65685425 207,5 L223,5 C223,6.65685425 224.343146,8 226,8 C227.656854,8 229,6.65685425 229,5 L245,5 C245,6.65685425 246.343146,8 248,8 C249.656854,8 251,6.65685425 251,5 L267,5 C267,6.65685425 268.343146,8 270,8 C271.656854,8 273,6.65685425 273,5 L289,5 C289,6.65685425 290.343146,8 292,8 C293.656854,8 295,6.65685425 295,5 L311,5 C311,6.65685425 312.343146,8 314,8 C315.656854,8 317,6.65685425 317,5 L319.501503,5 C320.88156,5 322,3.88071187 322,2.5 C322,1.10966206 320.881385,0 319.501503,0 L2.49849732,0 C1.11843975,0 0,1.11928813 0,2.5 C0,3.89033794 1.11861535,5 2.49849732,5 L179,5 Z"
        id="Combined-Shape"
        fill={style.leftFill}
      />
      <path
        d="M355,5 C355,6.65685425 356.343146,8 358,8 C359.656854,8 361,6.65685425 361,5 L377,5 C377,6.65685425 378.343146,8 380,8 C381.656854,8 383,6.65685425 383,5 L399,5 C399,6.65685425 400.343146,8 402,8 C403.656854,8 405,6.65685425 405,5 L421,5 C421,6.65685425 422.343146,8 424,8 C425.656854,8 427,6.65685425 427,5 L443,5 C443,6.65685425 444.343146,8 446,8 C447.656854,8 449,6.65685425 449,5 L465,5 C465,6.65685425 466.343146,8 468,8 C469.656854,8 471,6.65685425 471,5 L487,5 C487,6.65685425 488.343146,8 490,8 C491.656854,8 493,6.65685425 493,5 L509,5 C509,6.65685425 510.343146,8 512,8 C513.656854,8 515,6.65685425 515,5 L531,5 C531,6.65685425 532.343146,8 534,8 C535.656854,8 537,6.65685425 537,5 L553,5 C553,6.65685425 554.343146,8 556,8 C557.656854,8 559,6.65685425 559,5 L575,5 C575,6.65685425 576.343146,8 578,8 C579.656854,8 581,6.65685425 581,5 L597,5 C597,6.65685425 598.343146,8 600,8 C601.656854,8 603,6.65685425 603,5 L619,5 C619,6.65685425 620.343146,8 622,8 C623.656854,8 625,6.65685425 625,5 L641,5 C641,6.65685425 642.343146,8 644,8 C645.656854,8 647,6.65685425 647,5 L663,5 C663,6.65685425 664.343146,8 666,8 C667.656854,8 669,6.65685425 669,5 L685,5 C685,6.65685425 686.343146,8 688,8 C689.656854,8 691,6.65685425 691,5 L707,5 C707,6.65685425 708.343146,8 710,8 C711.656854,8 713,6.65685425 713,5 L729,5 C729,6.65685425 730.343146,8 732,8 C733.656854,8 735,6.65685425 735,5 L751,5 C751,6.65685425 752.343146,8 754,8 C755.656854,8 757,6.65685425 757,5 L773,5 C773,6.65685425 774.343146,8 776,8 C777.656854,8 779,6.65685425 779,5 L795,5 C795,6.65685425 796.343146,8 798,8 C799.656854,8 801,6.65685425 801,5 L817,5 C817,6.65685425 818.343146,8 820,8 C821.656854,8 823,6.65685425 823,5 L839,5 C839,6.65685425 840.343146,8 842,8 C843.656854,8 845,6.65685425 845,5 L861,5 C861,6.65685425 862.343146,8 864,8 C865.656854,8 867,6.65685425 867,5 L883,5 C883,6.65685425 884.343146,8 886,8 C887.656854,8 889,6.65685425 889,5 L905,5 C905,6.65685425 906.343146,8 908,8 C909.656854,8 911,6.65685425 911,5 L927,5 C927,6.65685425 928.343146,8 930,8 C931.656854,8 933,6.65685425 933,5 L949,5 C949,6.65685425 950.343146,8 952,8 C953.656854,8 955,6.65685425 955,5 L971,5 C971,6.65685425 972.343146,8 974,8 C975.656854,8 977,6.65685425 977,5 L993,5 C993,6.65685425 994.343146,8 996,8 C997.656854,8 999,6.65685425 999,5 C999,4.83973164 998.987432,4.68239859 998.963229,4.52893258 C999.591036,4.07494473 1000,3.3353143 1000,2.5 C1000,1.10966206 998.883637,0 997.506534,0 L354.493466,0 C353.117357,0 352,1.11928813 352,2.5 C352,3.89033794 353.116363,5 354.493466,5 L355,5 Z"
        id="Combined-Shape"
        fill={style.rightFill}
      />
    </g>
  </svg>
)

SettingsNumberLineNegativeScale.propTypes = {
  className: PropTypes.string.isRequired,
  style: PropTypes.shape({
    left: PropTypes.string,
    leftFill: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    rightFill: PropTypes.string.isRequired,
    top: PropTypes.string,
    transform: PropTypes.string,
  }).isRequired,
}

SettingsNumberLineNegativeScale.defaultProps = {
  left: null,
  top: null,
  transform: null,
}

export default SettingsNumberLineNegativeScale



// WEBPACK FOOTER //
// ./src/components/assets/SettingsNumberLineNegativeScale.js